import * as React from 'react'
import {
  Alert,
  AlertTitle,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  Grid2 as Grid,
  Link,
  Modal,
  Stack,
  Typography
} from '@mui/material'
import {PageLayout} from '@goschool/components'
import {Trans, useTranslation} from 'react-i18next'


export function ReceptionPage() {


  return <PageLayout title="Üdv az GoSchool platformon!" fullScreen={true} centered={true}>
    <Container maxWidth="md">
      <Stack spacing={2} sx={{textAlign: 'center', mb: 4}}>
        <Typography variant="h2" component="h1" gutterBottom={false}>
          <Trans i18nKey="landing:welcome"/>
        </Typography>
        <Typography variant="h6" fontWeight="light" color="text.secondary">
          <Trans i18nKey="landing:noCoursesYet"/>
        </Typography>
      </Stack>


      <Grid container spacing={6} rowSpacing={6}>
        <Grid size={{xs: 12, md: 6}}>
          <TeacherCard/>
        </Grid>

        <Grid size={{xs: 12, md: 6}}>
          <StudentCard/>
        </Grid>
      </Grid>
    </Container>
  </PageLayout>
}


function TeacherCard() {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const {t} = useTranslation()

  return <>
    <Card>
      <CardHeader title="Ha tanár vagy"/>
      <CardContent sx={{flexGrow: 1}}>
        <Typography variant="body1" gutterBottom>
          <Trans i18nKey="landing:teachers.info"/>
        </Typography>
        <Typography variant="body2">
          <Link href="https://goschool.ai/hu/oktatas/" target="_blank">
            <Trans i18nKey="landing:teachers.how"/>
          </Link>
        </Typography>
      </CardContent>
      <CardActions sx={{px: 2, pb: 2, pt: 0}}>
        <Button size="small" variant="contained" onClick={handleOpen}>
          <Trans i18nKey="landing:teachers.join.cta"/>
        </Button>
      </CardActions>
    </Card>
    <Modal
      open={open}
      onClose={handleClose}

      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"><Alert variant="filled" severity="info" sx={{
        position: 'absolute',
        top: '50%', left: '50%', transform: 'translate(-50%, -50%)', p: 4
      }}>
        <AlertTitle><Trans i18nKey="landing:teachers.join.title"/></AlertTitle>
        <Typography variant="body2" color="">
          <Trans i18nKey="landing:teachers.join.message"
            components={[<Link color="inherit" target="_blank" href={t('landing:teachers.join.contact')}/>]}/>
        </Typography>
      </Alert>
    </Modal>
  </>
}

function StudentCard() {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const {t} = useTranslation()


  return <>
    <Card>
      <CardHeader title="Ha diák vagy"/>
      <CardContent>
        <CardContent sx={{flexGrow: 1}}>
          <Typography variant="body1" gutterBottom>
            <Trans i18nKey="landing:students.info"/>
          </Typography>
          <Typography variant="body2">
            <Link href="https://goschool.ai/hu/oktatas/" target="_blank">
              <Trans i18nKey="landing:students.how"/>
            </Link>
          </Typography>
        </CardContent>
      </CardContent>
      <CardActions sx={{px: 2, pb: 2, pt: 0}}>
        <Button size="small" variant="contained" onClick={handleOpen}>
          <Trans i18nKey="landing:students.join.cta"/>
        </Button>
      </CardActions>
    </Card>
    <Modal
      open={open}
      onClose={handleClose}

      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"><Alert variant="filled" severity="info" sx={{
        position: 'absolute',
        top: '50%', left: '50%', transform: 'translate(-50%, -50%)', p: 4
      }}>
        <AlertTitle><Trans i18nKey="landing:students.join.title"/></AlertTitle>
        <Typography variant="body2" color="">
          <Trans i18nKey="landing:students.join.message"
            components={[<Link color="inherit" target="_blank" href={t('landing:students.join.contact')}/>]}/>
        </Typography>
      </Alert>
    </Modal>
  </>
}

